import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Typography, Button, styled } from '@mui/material';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getTextualContent } from '../apiCalls/games/api_v1_games';

const TrendingCard = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    height: '280px',
    marginTop:'5px',
    borderRadius: '12px',
    overflow: 'hidden',
    cursor: 'pointer',
    backgroundColor: '#2A2A2A',
    border: '2px solid #2A2A2A',
    borderTop: '2px solid #FAAE1C',
    '&:hover': {
        transform: 'scale(1.02)',
        transition: 'transform 0.2s ease-in-out',
        border: '2px solid #FAAE1C',
    },
    [theme.breakpoints.down('sm')]: {
        height: '250px',
    },
}));

const GameImage = styled(Box)(({ theme }) => ({
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "160px",
    borderRadius: "8px",
    [theme.breakpoints.down('sm')]: {
        height: "140px",
        

    },
    
}));

const TrendingTitle = styled(Typography)(({ theme }) => ({
    fontFamily: "'Poppins', sans-serif",
    fontSize: "14px",
    fontWeight: "600",
    textAlign: "center",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    marginBottom: "12px",
    paddingRight: "15px",
    marginLeft: "15px",
    [theme.breakpoints.down('md')]: {
        fontSize: "13px",
        marginBottom: "10px",
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: "12px",
        marginBottom: "8px",
        paddingRight: "10px",
        marginLeft: "10px",
    },
}));

const TrendingButton = styled(Button)(({ theme }) => ({
    fontFamily: "'Poppins', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    color: '#F2BC1A',
    textTransform: 'none',
    padding: '10px 12px',
    backgroundColor: 'rgb(55, 55, 55)',
    border: '1px solid rgb(55, 55, 55)',
    borderRadius: '8px',
    minWidth: 'auto',
    width: 'auto',
    maxWidth: '90%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&:hover': {
        backgroundColor: '#F2BC1A',
        color: '#000',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '13px',
        padding: '8px 10px',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
        padding: '6px 8px',
    },
}));

const TrendingSlider = styled(Slider)(({ theme }) => ({
    '& .slick-dots li button:before': {
        color: '#888888',
    },
    '& .slick-dots li.slick-active button:before': {
        color: '#FAAE1C',
    },
    '& .slick-list': {
        margin: '0 -8px',
        [theme.breakpoints.down('sm')]: {
            margin: '0 -4px',
        },
    },
    '& .slick-slide > div': {
        padding: '0 8px',
        [theme.breakpoints.down('sm')]: {
            padding: '0 4px',
        },
    },
}));

function Trending() {
    const theme = useTheme();
    const [trendingItems, setTrendingItems] = useState([]);
    const [slidesToShow, setSlidesToShow] = useState(1);
    const navigate = useNavigate();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const fetchTrending = async () => {
            try {
                const res = await getTextualContent({});
                if (res.data.success) {
                    const items = res.data.data.map(article => ({
                        id: article.id,
                        title: article.title,
                        image: article.image,
                        type: article.type,
                        content: article.content,
                        tags: article.tags,
                        gameName: article.game_name,
                       rating: article.rating

                    }));
                    setTrendingItems(items);
                }
            } catch (error) {
                console.error("Error fetching trending articles:", error);
            }
        };
        fetchTrending();
    }, []);

    useEffect(() => {
        const updateSlides = () => {
            const width = window.innerWidth;
            if (width >= 1600) setSlidesToShow(5);
            else if (width >= 1200) setSlidesToShow(4);
            else if (width >= 900) setSlidesToShow(3);
            else if (width >= 600) setSlidesToShow(2);
            else setSlidesToShow(1);
        };

        updateSlides();
        window.addEventListener('resize', updateSlides);
        return () => window.removeEventListener('resize', updateSlides);
    }, []);

    console.log("my trending items", trendingItems);

    const settings = {
        dots: true,
        infinite: trendingItems.length > 1,
        speed: 500,
        slidesToShow,
        slidesToScroll: 1,
        autoplay: trendingItems.length > 0,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: isSmallScreen ? false : true,
                }
            }
        ]
    };

    return (
        <Box sx={{ px: { xs: 1, sm: 2 } }}>
            {trendingItems.length > 0 && (
                <TrendingSlider {...settings}>
                    {trendingItems.map((item) => (
                        <Box key={item.id}>
                            <TrendingCard>
                                <GameImage loading="lazy" sx={{ backgroundImage: `url(${item.image})` }} />
                                <Box
                                    sx={{
                                        padding: { xs: "8px", sm: "10px" },
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: "5px",
                                    }}
                                >
                                    <TrendingTitle>{item.title}</TrendingTitle>
                                    <TrendingButton
                                        onClick={() =>
                                            navigate("/article-view", {
                                                state: { article: item, gameName: item.gameName || "" },
                                            })
                                        }
                                    >
                                        Read {item.type === "prosandcons" ? "Pros & Cons" : item.type.charAt(0).toUpperCase() + item.type.slice(1).toLowerCase()}
                                    </TrendingButton>
                                </Box>
                            </TrendingCard>
                        </Box>
                    ))}
                </TrendingSlider>
            )}
        </Box>
    );
}

export default Trending;